import { createFileRoute } from "@tanstack/react-router";

import ExplorePage from "@/app/design-system/explore/ExplorePage";

export const Route = createFileRoute("/admin/design-system/explore")({
  component: ExplorePage,
});
